import styled, {css} from "styled-components";

interface IStickyNavigationMenuLinkDefaultBoxProps {
    isActive: boolean
}

export const BottomNavigationBarMenuItemTextDefaultBox = styled.div<IStickyNavigationMenuLinkDefaultBoxProps>`
  color: ${props => props.theme.colors.text};
  text-transform: capitalize;
  font-size: 1.1em;
  
  ${props => props.isActive && css`
    color: ${props => props.theme.colors.textLight};
    font-weight: 600;
  `}
  
`;